export default {
  course: null,
  courses: null
};
